<template>
  <section class="voting-terminal" :class="`voting-terminal--${content.tone}`">
    <div class="voting-terminal__icon" aria-hidden="true">{{ content.icon }}</div>
    <h1>{{ content.title }}</h1>
    <p>{{ content.message }}</p>
    <router-link class="voting-terminal__back" :to="dashboardRoute">
      Volver a mis votaciones
    </router-link>
  </section>
</template>

<script>
import { formatVotingDate } from "@/share/voting";

export default {
  name: "VotingTerminalState",
  props: {
    reason: { type: String, default: "ELECTION_CLOSED" },
    submittedAt: { type: [String, Date], default: null },
    dashboardRoute: { type: Object, required: true },
  },
  computed: {
    content() {
      const date = this.submittedAt ? ` el ${formatVotingDate(this.submittedAt)}` : "";
      const values = {
        ALREADY_SUBMITTED: {
          title: `Ya emitiste tu voto${date}`,
          message: "Tu participación ya fue registrada. Gracias por participar.",
          icon: "✓",
          tone: "success",
        },
        TOKEN_REVOKED: {
          title: "Tu acceso fue revocado",
          message: "Contacta a ASOFOM si necesitas más información.",
          icon: "!",
          tone: "error",
        },
        TOKEN_EXPIRED: {
          title: "Tu acceso expiró",
          message: "Solicita un nuevo acceso a ASOFOM si la ventana sigue abierta.",
          icon: "!",
          tone: "warning",
        },
        ELECTION_CLOSED: {
          title: "La ventana de votación está cerrada",
          message: "Ya no se aceptan votos para este proceso.",
          icon: "!",
          tone: "warning",
        },
        BALLOT_EXPIRED: {
          title: "La boleta expiró",
          message: "La ventana de votación terminó antes de que enviaras tu boleta.",
          icon: "!",
          tone: "warning",
        },
        NOT_OPEN: {
          title: "La votación aún no está abierta",
          message: "Vuelve a abrir este proceso durante el horario indicado.",
          icon: "!",
          tone: "warning",
        },
      };
      return values[this.reason] || {
        title: "La boleta no está disponible",
        message: "El proceso no puede continuar con este acceso.",
        icon: "×",
        tone: "error",
      };
    },
  },
};
</script>

<style scoped>
.voting-terminal {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 620px;
  margin: 48px auto;
  border-radius: 22px;
  padding: 42px 28px;
  background: #ffffff;
  box-shadow: 0 12px 32px rgba(27, 39, 62, 0.09);
  text-align: center;
}

.voting-terminal__icon {
  display: flex;
  width: 72px;
  height: 72px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 900;
}

.voting-terminal--success .voting-terminal__icon {
  background: #e7f6ea;
  color: #237b37;
}

.voting-terminal--warning .voting-terminal__icon {
  background: #fff3d6;
  color: #a66f00;
}

.voting-terminal--error .voting-terminal__icon {
  background: #fde8e8;
  color: #b42318;
}

.voting-terminal h1 {
  margin: 22px 0 0;
  color: #1b273e;
  font-size: 26px;
  line-height: 1.25;
}

.voting-terminal p {
  max-width: 440px;
  margin: 10px 0 0;
  color: #687386;
  font-size: 15px;
  line-height: 1.6;
}

.voting-terminal__back {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  margin-top: 26px;
  border-radius: 999px;
  padding: 10px 18px;
  background: #1b273e;
  color: #ffffff;
  font-size: 14px;
  font-weight: 800;
  text-decoration: none;
}
</style>
